import React from 'react';
import { Card, CardContent } from '../../../shared/components/ui/Card';

export default function ActivityLog({ logs }) {
    return (
        <Card>
            <CardContent className="p-4">
                <h2 className="font-bold text-lg mb-4">Recent Activity</h2>
                <ul className="divide-y divide-gray-200 text-sm">
                    {logs.length === 0 ? (
                        <li className="py-2 text-gray-500">No recent activity</li>
                    ) : (
                        logs.map((log, idx) => (
                            <li key={idx} className="py-3">
                                <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:items-start">
                                    <span className="text-gray-800 min-w-0 flex-1">
                                        {log.icon} {log.message}
                                    </span>
                                    <span className="text-gray-400 text-xs whitespace-nowrap shrink-0 sm:ml-2">
                                        {log.timestamp}
                                    </span>
                                </div>
                            </li>
                        ))
                    )}
                </ul>
            </CardContent>
        </Card>
    );
}
